module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABASURBVHgBzY+xCQAgDARfcQsVHMH9G1dwI7VIIa9FihQ5CA9HAnmAKLmNeoZ9hBL7xfD5p0vOW6bFl5LsHxy23vbECIJAa9UZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Plus-icon.png
// module id = 3413
// module chunks = 0